<template>
  <el-dropdown>
    <el-button>
      Exportar
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item><span @click="doexport('csv')">CSV</span></el-dropdown-item>
      <el-dropdown-item><span @click=" doexport('xls')">XLS</span></el-dropdown-item>
      <el-dropdown-item><span @click=" doexport('html')">HTML</span></el-dropdown-item>
      <el-dropdown-item><span @click=" doexport('xml')">XML</span></el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "PageExportOptions",
  methods: {
    doexport(type) {
      this.$emit("export", type);
    },
  }
}
</script>